<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Добавление пользователя</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.name"
                    label="Имя"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.surname"
                    label="Фамилия"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.phoneNumber"
                    label="Номер телефона"
                    :value="formatPhone(editedItem.phoneNumber)"
                    @input="updatePhone"
                ></v-text-field>
              </v-col>
              <v-col cols="12"
                     sm="6"
                     md="4">
                <v-select v-model="editedItem.role" :items="roles" label="Роль" />
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.password"
                    type="password"
                    label="Пароль"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="save"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Пользователи
      </v-card-title>
    </v-card>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-btn color="primary" dark class="mb-4 mt-4">
                  <v-icon left>mdi-plus</v-icon> Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
              class="mr-2"
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'PartnerUsers',
  data() {
    return {
      editedItem: {
        jobName: null,
        price: null,
        duration: null,
        categoryId: null,
        serviceJobs: null,
      },
      editDialog: false,
      data: [],
      size: 10,
      roles: ['Снабженец', 'Сотрудник'],
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Номер телефона', value: 'username' },
        { text: 'Имя', value: 'name' },
        { text: 'Фамилия', value: 'surname' },
        { text: 'Дата создания', value: 'createdAt' },
        { text: 'Роль', value: 'role.name' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {},
      jobs: [],
      categories: [],
      isEditing: false,
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
    this.getJobsHistory()
    this.getPartnerCategories()
  },
  methods: {
    updatePhone(value) {
      const digits = value.replace(/\D/g, '').slice(0, 10)
      const formatted = this.formatPhone(digits)
      this.editedItem.phoneNumber = formatted
    },
    formatPhone(digits) {
      if (!digits) return '+7 '
      const part1 = digits.substring(0, 3)
      const part2 = digits.substring(3, 6)
      const part3 = digits.substring(6, 8)
      const part4 = digits.substring(8, 10)
      return `+7 (${part1}${part1.length === 3 ? ')' : ''}${part2 ? ' ' + part2 : ''}${part3 ? '-' + part3 : ''}${part4 ? '-' + part4 : ''}`
    },
    addUser() {
      this.editDialog = true
    },
    async getJobsHistory () {
      try {
        this.jobs = await this.$store.dispatch('partnerJobs/getJobsHistory')
      } catch (e) {
        console.log(e)
      }
    },
    async getPartnerCategories () {
      try {
        this.categories = await this.$store.dispatch('partnerJobs/getPartnerCategories')
      } catch (e) {
        console.log(e)
      }
    },
    close () {
      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        jobName: null,
        price: null,
        duration: null,
        category: null,
      }
    },
    async save () {
      console.log(this.editedItem)
      try {
        this.editedItem.categoryId = this.editedItem.categoryId.toString()
        await this.$store.dispatch('partnerJobs/createJob', this.editedItem)
        showSnackbar({
          message: "Успешно добавлено!",
          color: "success",
          timeout: 3000,
        })
      } catch (e) {
        showSnackbar({
          message: "Не удалось добавить",
          color: "error",
          timeout: 3000,
        })
      }
      this.editDialog = false
      this.editedItem = {
        jobName: null,
        price: null,
        duration: null,
        category: null,
      }
    },
    async deleteItem (item) {
      try {
        if (confirm('Вы точно хотите удалить данные?')) {
          await this.$store.dispatch('partnerUsers/deleteUser', item.id)
          this.getData()
          showSnackbar({
            message: "Успешно удалено!",
            color: "success",
            timeout: 3000,
          })
        }
      } catch (e) {
        showSnackbar({
          message: "Не удалось удалить",
          color: "error",
          timeout: 3000,
        })
      }
    },
    async getData () {
      try {
        const data = await this.$store.dispatch('partnerUsers/getPartnerUsers')
        this.data = data.map((item) => {

          return item
        })
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
<style scoped>

</style>